import { defineStore } from 'pinia';

export interface TimeTrackingState {
  openTimeEntryModal: boolean;
  /**
   * Timestamp of the last time entry modification.
   * Components watching this can refresh their data when it changes.
   */
  lastEntryUpdate: number;
  /**
   * The item number that was updated (to filter refreshes to relevant components)
   */
  lastUpdatedItemNumber: string | null;
}

/**
 * Time tracking store - manages UI state for time tracking modals
 *
 * Note: CRUD operations are handled directly via TimeTrackingService in components
 * to allow for proper error handling and Pusher event integration at the component level.
 */
export const useTimetrackingStore = defineStore('timetracking', {
  state: (): TimeTrackingState => {
    return {
      openTimeEntryModal: false,
      lastEntryUpdate: 0,
      lastUpdatedItemNumber: null,
    };
  },

  actions: {
    setOpenTimeEntryModal(open: boolean) {
      this.openTimeEntryModal = open;
    },

    /**
     * Notify all time tracking components that entries have changed for an item.
     * This triggers a refresh in components displaying that item's time entries.
     */
    notifyEntryChanged(itemNumber: string) {
      this.lastUpdatedItemNumber = itemNumber;
      this.lastEntryUpdate = Date.now();
    },
  },
});
